/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-payment.vue?vue&type=template&id=a48367c0&scoped=true&"
import script from "./authorize-payment.vue?vue&type=script&lang=js&"
export * from "./authorize-payment.vue?vue&type=script&lang=js&"
import style0 from "./authorize-payment.vue?vue&type=style&index=0&id=a48367c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48367c0",
  null
  
)

export default component.exports